<template>
  <div class="flex items-center justify-between mb-4">
    <p class="col-span-6 text-fg-default font-semibold">{{ title }}</p>
    <div
      @click="copyAllHandler(details)"
      class="flex items-center gap-x-1 cursor-pointer pr-4"
    >
      <p class="text-13px font-normal text-primary">Copy All</p>
      <copy-icon />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyAccountDetails',
  props: {
    title: {
      type: String,
      default: 'Account Details'
    },
    details: {
      type: Object,
      required: true
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  }
}
</script>
